import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

/**
 * [2026-02-09:Jeyoung Lee] FIXME: 서울시 임시 페이지
 * @link https://hmg.atlassian.net/browse/DRIVINGINS-2884
 */
function MileageSignupEligibilityBottomSheetImsiKr() {
  const {t} = useInferableTranslation();
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={300}>
      <div className="bottom_sheet">
        <div className="bottom_sheet_header">
          <h2
            className="bottom_sheet_title"
            style={{whiteSpace: 'pre-wrap'}}
          >
            서울시 에코마일리지(승용차)에 참여할 수 없는 차량이에요
          </h2>
          <button
            type="button"
            className="btn btn_ic"
            aria-label={t('T10017')}
            onClick={() => window.bottomSheetClose(null)}
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        <div className="bottom_sheet_inner">
          <div className="bottom_sheet_contents">
            <strong className="bottom_sheet_title_sub">서비스 정책 변경으로 도전참여가 불가능해요. 도전 가능한 조건을 확인하세요.</strong>
            <div
              className="bottom_sheet_container"
              style={{whiteSpace: 'pre-wrap'}}
            >
              <p className="bottom_sheet_notice">도전 가능 차량</p>
              <ul className="bottom_sheet_list">
                <li className="bottom_sheet_item text_bold">서울시에 등록된 차량</li>
                <li className="bottom_sheet_item text_bold">12인승 이하 비사업용 승용•승합차량 (전기,수소차,일부 하이브리드차 제외)</li>
                <li className="bottom_sheet_item text_bold">{t('T40084')}</li>
              </ul>
            </div>
            <strong className="bottom_sheet_title_sub">정책 관련 문의사항은 고객센터(1899-2121)로 문의해 주세요.</strong>
          </div>

          <div className="bottom_sheet_footer bottom_sheet_footer_complex">
            <button
              type="button"
              className="btn btn_large btn_outline"
              onClick={() => window.bottomSheetClose(false)}
            >
              {t('T10017')}
            </button>

            <button
              type="button"
              className="btn btn_large btn_filled"
              onClick={() => window.bottomSheetClose(true)}
            >
              {t('T10114')}
            </button>
          </div>
        </div>
      </div>
    </BottomSheetWebViewWrapper>
  );
}

export default MileageSignupEligibilityBottomSheetImsiKr;
